<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay" @click.self="$emit('close')">
      <div class="modal-window">
        <div class="modal-content">
          <section class="list-box white-box row">
            <h2 class="modal-title">登録削除</h2>
            <p>このユーザーの登録を削除しますか？</p>
            <form>
              <table class="register-table">
                <tr>
                  <th>メールアドレス</th>
                  <td>{{user.email}}</td>
                </tr>
                <tr>
                  <th>氏名</th>
                  <td>{{user.name}}</td>
                </tr>
                <tr>
                  <th>性別</th>
                  <td v-if="user.gender === 0">男性</td>
                  <td v-if="user.gender === 1">女性</td>
                  <td v-if="user.gender === 2">無回答</td>
                </tr>
                <tr>
                  <th>部署名</th>
                  <td>{{user.department}}</td>
                </tr>
                <tr>
                  <th>役職</th>
                  <td>{{user.position}}</td>
                </tr>
              </table>
              <div class="modal-btn">
                <span class="btn-gray2"><button @click.prevent="$emit('close')">キャンセル</button></span>
                <span class="btn-gray2"><button @click.prevent="deleteBtnClick">削除する</button></span>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import httpResource from '../http/httpResource'
import store from '../store/index'
export default {
  props: ['user'],
  methods: {
    async deleteBtnClick () {
      try {
        const response = await httpResource.delete('/corporation/users', {data: this.user.id, headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          this.$emit('reloadData')
          this.$emit('close')
        }
      } catch (error) {
        console.log(error.response.data)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DeleteUser.vue